const ON_CHANGE_DEBOUNCE_TIMER = 300

const EVENTS = {
  sectionInView: 'section-in-view',
  domready: 'domready',
  intersection: 'intersection',
  device: 'device',
}

const ELEMENTS = {
  section: '.scroll',
}

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
